import { createAsyncThunk } from "@reduxjs/toolkit";

import {
    DELETE_BOOKMARK, DOWNLOAD_CONTRACT, GET_BANNER,
    GET_CITIES, GET_PRODUCT_IMAGE, GET_PRODUCT_OWNER,
    GET_PRODUCT_SUB_CATEGORY_LIST, GET_PRODUCT_THUMBNAIL,
    GET_PROVINCE, GET_USER,
    GET_USER_CITIES, PRODUCT_REPORT,
    REGISTER_USER_CITIES, UPLOAD_IMAGE, VERIFY_IDENTITY
} from "./shared.type";
import SharedService from "../services/Shared.service";
import {CitiesFilter, RegisterReportModel, UserCities} from "../models";

export const getProductCategoryList = createAsyncThunk(
    GET_PRODUCT_SUB_CATEGORY_LIST,
    async () =>{
        const response = await SharedService.getProductCategoryList();
        return response.data;
    }
)
export const getProductSubCategoryList = createAsyncThunk(
    GET_PRODUCT_SUB_CATEGORY_LIST,
    async (id:number) =>{
        const response = await SharedService.getProductSubCategoryList(id);
        return response.data;
    }
)
export const getProvinces = createAsyncThunk(
    GET_PROVINCE,
    async () =>{
        const response = await SharedService.getProVince();
        return response.data;
    }
)
export const getCities = createAsyncThunk(
    GET_CITIES,
    async (model:CitiesFilter) =>{
        const response = await SharedService.getCities(model);
        return response.data;
    }
)
export const registerUserCities = createAsyncThunk(
    REGISTER_USER_CITIES,
    async (ids:UserCities) =>{
        const response = await SharedService.registerUserCities(ids);
        return response.data;
    }
)
export const getUserCities = createAsyncThunk(
    GET_USER_CITIES,
    async () =>{
        const response = await SharedService.getUserCities();
        return response.data;
    }
)
export const getProductThumbnail = createAsyncThunk(
    GET_PRODUCT_THUMBNAIL,
    async (id:string) =>{
        const response = await SharedService.getProductThumbnail(id);
        return response.data;
    }
)
export const getProductImage = createAsyncThunk(
    GET_PRODUCT_IMAGE,
    async (id:string) =>{
        const response = await SharedService.getProductImage(id);
        return response.data;
    }
)
export const deleteBookmark = createAsyncThunk(
    DELETE_BOOKMARK,
    async (id:string) =>{
        const response = await SharedService.deleteBookmark(id);
        return response.data;
    }
)
export const registerReport = createAsyncThunk(
    PRODUCT_REPORT,
    async (model:RegisterReportModel) =>{
        const response = await SharedService.registerReport(model);
        return response.data;
    }
)
export const getUser = createAsyncThunk(
    GET_USER,
    async () =>{
        const response = await SharedService.getUser();
        return response.data;
    }
)
export const verifyIdentity = createAsyncThunk(
    VERIFY_IDENTITY,
    async (nationalCode:number) =>{
        const response = await SharedService.verifyIdentity(nationalCode);
        return response.data;
    }
)
export const getBanner = createAsyncThunk(
    GET_BANNER,
    async (model:any) =>{
        const response = await SharedService.getBanner(model);
        return response.data;
    }
)
export const getProductOwner = createAsyncThunk(
    GET_PRODUCT_OWNER,
    async (id:string) =>{
        const response = await SharedService.getProductOwner(id);
        return response.data;
    }
)
export const uploadImage = createAsyncThunk(
    UPLOAD_IMAGE,
    async (model:any) =>{
        const response = await SharedService.uploadImage(model);
        return response.data;
    }
)
export const DownloadContract = createAsyncThunk(
    DOWNLOAD_CONTRACT,
    async (id:any) =>{
        const response = await SharedService.downloadContract(id);
        return response.data;
    }
)

